import React, { useEffect } from "react";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import CalendarInput from "../../Common/FormElements/CalendarInput/CalendarInput";
import ListDeleteIcon from "../../Common/DeleteIcon/ListDeleteIcon";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePayment,
  updateCommande,
} from "../../../REDUX/actions/commandes";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { openCenteredModal } from "../../../REDUX/actions/centeredModal";
import ConfirmModal from "../../Common/Modal/ConfirmModal";
import MediaPreview from "../../Common/MediaPreview";
import { IMAGE_END_POINT } from "../../../Api/EndPoints";
import { deleteDepositInvoice } from "../../../REDUX/actions/catalogue";
import { deleteInvoice } from "../../../REDUX/actions/invoices";

function PaiementItem({
  index,
  id,
  amount,
  date,
  type,
  formData,
  setFormData,
  newPayment,
  factureMedia,
  acompteFactureId,
  setMustTotalPay,
  factureNb,
  factureDate,
  isShowInvoiceNbAndDateUpdate,
  isSoldInvoice,
}) {
  const { t } = useTranslation("common");
  const { user } = useSelector((state) => state.userReducer);

  const dispatch = useDispatch();

  const handleAmountChange = (e) => {
    setFormData({
      ...formData,
      payments: formData?.payments?.map((payment) => {
        return payment.id === id
          ? { ...payment, amount: e.target.value }
          : payment;
      }),
    });
  };
  const handleDateChange = (e) => {
    setFormData({
      ...formData,
      payments: formData?.payments?.map((payment) => {
        return payment.id === id ? { ...payment, date: e.value } : payment;
      }),
    });
  };

  const handleInvoiceDateChange = (e) => {
    let shouldUpdateFacture = false;

    const updatedPayments = formData?.payments?.map((payment) => {
      if (+payment.id === +id) {
        if (payment?.acompte_facture) {
          return {
            ...payment,
            acompte_facture: {
              ...payment.acompte_facture,
              date: e.value,
            },
          };
        } else {
          shouldUpdateFacture = true;
        }
      }
      return payment;
    });

    shouldUpdateFacture
      ? setFormData({
          ...formData,
          payments: updatedPayments,
          factureDate: e.target.value.toString(),
          facture: {
            ...(formData.facture || {}),
            date: e.target.value.toString(),
          },
        })
      : setFormData({
          ...formData,
          payments: updatedPayments,
        });
  };

  const handleInvoiceNbChange = (e) => {
    let shouldUpdateFacture = false;

    const updatedPayments = formData?.payments?.map((payment) => {
      if (+payment.id === +id) {
        if (!payment?.acompte_facture) {
          shouldUpdateFacture = true;
        } else {
          return {
            ...payment,
            acompte_facture: {
              ...payment.acompte_facture,
              number: e.target.value,
            },
          };
        }
      }
      return payment;
    });

    shouldUpdateFacture
      ? setFormData({
          ...formData,
          payments: updatedPayments,
          factureNumber: e.target.value.toString(),
          facture: {
            ...(formData.facture || {}),
            number: e.target.value.toString(),
          },
        })
      : setFormData({
          ...formData,
          payments: updatedPayments,
        });
  };

  const callBack = (id) => {
    const sumPayments = formData?.payments
      ?.filter((payment) => payment?.id !== id)
      ?.reduce((acc, curr) => acc + (curr?.amount || 0), 0);

    if (sumPayments > 0) {
      if (formData?.totalTTC > sumPayments) {
        dispatch(updateCommande(formData?.id, { payStatus: "Acompte payé" }));
      }
    } else {
      dispatch(updateCommande(formData?.id, { payStatus: "En attente" }));
    }

    if (isSoldInvoice) {
      dispatch(deleteInvoice({ id: formData?.facture?.id }));
      dispatch(
        updateCommande(formData?.id, { factureNumber: null, factureDate: null })
      );
    } else {
      dispatch(deleteDepositInvoice(acompteFactureId));
    }
  };

  const handleDelete = () => {
    if (newPayment) {
      setFormData({
        ...formData,
        payments: formData?.payments?.filter((payment) => payment?.id !== id),
      });
    } else {
      // if (formData?.payStatus !== "Payée") {
      // formData?.payments?.length === 1 &&
      // formData?.payments[0]?.id === id &&
      // dispatch(deleteInvoice({ id: formData?.invoice?.id }));
      type === "Crédit agricole"
        ? toast.error(
            t("You can no longer cancel an automatic Crédit Agricole payment!")
          )
        : dispatch(
            openCenteredModal(
              <ConfirmModal
                label={t("this payment")}
                // id={id}
                onConfirm={() =>
                  dispatch(
                    deletePayment({ id, commandeID: formData?.id, callBack })
                  )
                }
              />
            )
          );
    }
  };

  // useEffect(() => {
  //   amount &&
  //     +formData?.totalTTC < 2000 &&
  //     +amount < formData?.totalTTC?.toFixed(2) &&
  //     setMustTotalPay(true);
  //   return () => {
  //     setMustTotalPay(false);
  //   };
  // }, [formData?.totalTTC, amount, setMustTotalPay]);

  return (
    <div className="alignH px-4 py-3 b-1-bottom-softGrey gap-2">
      <p className={`w10 f12 mb-0 text-softBlack `}>
        {t("Payment")} {index + 1}
      </p>
      <div className={`${"w20"} pe-4`}>
        <TextInput
          euro
          value={amount}
          callback={handleAmountChange}
          inputClassName={"f12"}
          placeholderStyle={"f12"}
          type="number"
          disabled={
            user?.attributes?.userRole !== 1 || type === "Crédit agricole"
          }
        />
      </div>
      <div className={`${"w20"} pe-4`}>
        <CalendarInput
          className="paymentDateInput b-2-softGrey w100"
          customInputStyle={{ fontSize: "12px" }}
          placeholder={t("Payment date")}
          calendarIconSize={"16px"}
          callback={handleDateChange}
          value={date ? moment(date).utc(true).toDate() : undefined}
          withMinDate={false}
          disabled={
            user?.attributes?.userRole !== 1 || type === "Crédit agricole"
          }
        />
      </div>
      <div className={`${isShowInvoiceNbAndDateUpdate ? "w15" : "w20"}`}>
        <span className="f12">{t(type)}</span>
      </div>
      <div className={`${isShowInvoiceNbAndDateUpdate ? "w15" : "w20"}`}>
        <div className="buttonsContainer ms-auto">
          {factureMedia?.url ? (
            <>
              <button
                className="br50 p-1 me-2 border-0 bg-transparent"
                onClick={() => {
                  window.open(`${IMAGE_END_POINT}${factureMedia?.url}`);
                }}
              >
                <i className="bi bi-eye text-blue f18" />
              </button>
            </>
          ) : null}
        </div>
      </div>

      {isShowInvoiceNbAndDateUpdate && (
        <>
          <div className="w15 pe-4">
            {!newPayment && (
              <TextInput
                value={factureNb}
                callback={handleInvoiceNbChange}
                inputClassName={"f12"}
                placeholderStyle={"f12"}
                type="number"
                disabled={user?.attributes?.userRole !== 1}
              />
            )}
          </div>
          <div className="w15 pe-4">
            {!newPayment && (
              <CalendarInput
                className="paymentDateInput b-2-softGrey w100"
                customInputStyle={{ fontSize: "12px" }}
                placeholder={t("Invoice date")}
                calendarIconSize={"16px"}
                callback={handleInvoiceDateChange}
                value={
                  factureDate
                    ? moment(factureDate).utc(true).toDate()
                    : undefined
                }
                withMinDate={false}
                disabled={user?.attributes?.userRole !== 1}
              />
            )}
          </div>
        </>
      )}
      {user?.attributes?.userRole === 1 && (
        <div className="w5">
          <ListDeleteIcon callback={handleDelete} />
        </div>
      )}
    </div>
  );
}

export default PaiementItem;
